import { components } from "react-select";

// Reusable CustomValueContainer for react-select
export const CustomValueContainer = ({ children, ...props }) => {
  const selectedValues = props.getValue();
  const length = selectedValues.length;

  if (length > 10) {
    return (
      <components.ValueContainer {...props}>
        {length >= 30 ? `${length} selected` : `${length} selected`}
      </components.ValueContainer>
    );
  }
  return (
    <components.ValueContainer {...props}>{children}</components.ValueContainer>
  );
};

// Reusable utility for handling Select All in react-select
export const handleSelectAll = (
  selectedOptions,
  data,
  fieldName,
  setValue,
  trigger,
  callback
) => {
  if (!selectedOptions) selectedOptions = [];
  let finalSelected = selectedOptions;
  if (selectedOptions.some((opt) => opt.value === "*")) {
    finalSelected = data.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }
  setValue(fieldName, finalSelected);
  if (callback) callback(finalSelected);
  trigger(fieldName);
};
